import * as React from 'react';
import { useIsMounted } from '~/Utils/Hooks/useIsMounted';
import { ClientSidePortal } from './ClientSidePortal';

export const Portal: React.FC<React.PropsWithChildren> = props => {
    const { children } = props;
    const isMounted = useIsMounted();

    return isMounted ? <ClientSidePortal>{children}</ClientSidePortal> : null;
};
